// src/components/store/sections/blog-posts/BlogV37GridcardsOceanCyan.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV37GridcardsOceanCyan(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={37}
      archKey="grid_cards"
      archLabel="Modern Card Grid"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
